import { useEffect, useState } from 'react';
import { ModalPanel } from '@/contasis';

const SEGUNDOS_INICIALES = 8;

export interface ModalRedireccionPagoProps {
  isOpen: boolean;
  onRedirect: () => void;
}

export const ModalRedireccionPago = ({ isOpen, onRedirect }: ModalRedireccionPagoProps) => {
  const [countdown, setCountdown] = useState(SEGUNDOS_INICIALES);

  useEffect(() => {
    if (!isOpen) {
      setCountdown(SEGUNDOS_INICIALES);
      return;
    }
    if (countdown <= 0) {
      onRedirect();
      return;
    }
    const t = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [isOpen, countdown, onRedirect]);

  if (!isOpen) return null;

  return (
    <ModalPanel
      isOpen={isOpen}
      title="Un momento..."
      onClose={() => {}}
      closeOnClickOutside={false}
      closeOnEsc={false}
      disableClose
      size="small"
    >
      <div className="px-6 py-10 flex flex-col items-center text-center gap-3">
        <p className="text-body-sm text-secondary">
          Te vamos a redirigir para que completes tu pago.
        </p>
        <p className="text-caption text-tertiary">
          Redirigiendo en {countdown}s...
        </p>
      </div>
    </ModalPanel>
  );
};
